var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hr',{staticStyle:{"border-color":"transparent"}}),_c('section',{staticClass:"mt-5 mb-5 white px-10 py-7 text-justify"},[_c('div',{staticClass:"my-4 col-md-10 mx-auto",attrs:{"id":"content"},domProps:{"innerHTML":_vm._s(_vm.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }